export enum EUserAuthQueryKey {
  USER_AUTH_DETAILS = 'user-auth-details',
}
